import { KYMW2000Model } from '../kymw2000.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { GetCycleMediumList } from '../vo/get-cycle-medium-list.model';

// レスポンス構造
interface GetCycleMediumListResponse {
  MediumType: string,
  MediumName: string,
}

/**
 * サイクル商品選定対象媒体一覧取得するサービス
 *
 * @export GetCycleMediumListService
 * @class GetCycleMediumListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCycleMediumListService extends PlessJsonResponderSub<any> {

  private model: KYMW2000Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCycleMediumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCycleMediumListService
   */
  execute(model: KYMW2000Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getCycleMediumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCycleMediumListService
   */
  success(data: GetCycleMediumListResponse[]): void {
    if (data !== null) {
      this.model.mediumList = data.map(item => new GetCycleMediumList(
        item.MediumType,
        item.MediumName,
      ));
      if (this.calbak) this.calbak();
    }
  }
}
